import { TOptions } from "i18next";
import { useTranslation } from "react-i18next";

interface CustomTabulationProps<T extends Record<string, string | number>> {
    tabsEnum: T;
    tabName: T[keyof T];
    tabSwitchHandler: (tab: T[keyof T]) => void;
    tabTitleKey: string;
    tabTitleInterpolationObject?: TOptions;
    wrapClassName?: string;
    unorderedListClassName?: string;
    listItemClassName?: string;
    tabNameActiveClassName?: string;
    tabNameClassName?: string;
}

const CustomTabulation = <T extends Record<string, string | number>>(props: CustomTabulationProps<T>) => {
    const { t } = useTranslation();
    return (
        <div className={props.wrapClassName}>
            <ul className={`flex ${props.unorderedListClassName}`}>
                {Object.values(props.tabsEnum).map((tab, index) => (
                    <li className={props.listItemClassName} key={`a-tabulation-${index}`}>
                        <div
                            className={`inline-block cursor-pointer transition-all duration-300 ${
                                props.tabName === tab ? props.tabNameActiveClassName : props.tabNameClassName
                            }`}
                            onClick={() => props.tabSwitchHandler(tab as T[keyof T])}
                        >
                            {t(`${props.tabTitleKey}.${tab}`, props.tabTitleInterpolationObject)}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CustomTabulation;
